module.exports = __webpack_public_path__ + "static/img/bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/bg.png
// module id = 540
// module chunks = 0